const heroStats = [
  { value: '14,200+', label: '收录作品' },
  { value: '每日', label: '更新连载' },
  { value: '高清', label: '默认画质' },
];

export default function HeroSection() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-50 pt-24 md:pt-28 pb-14 md:pb-20">
      <div className="pointer-events-none absolute -top-24 -right-24 w-[420px] h-[420px] rounded-full bg-primary-100/60 blur-3xl"></div>
      <div className="pointer-events-none absolute bottom-0 -left-24 w-[360px] h-[360px] rounded-full bg-accent-100/60 blur-3xl"></div>

      <div className="relative w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="animate-fade-up">
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-800 text-xs font-medium">
              <i className="ri-flower-fill"></i>
              樱花动漫在线 · 作品信息整理
            </span>

            <h1 className="mt-5 font-heading text-3xl md:text-5xl font-semibold leading-tight text-foreground-950">
              樱花动漫在线观看
              <span className="block mt-2 text-primary-600">把想看的作品先看清楚</span>
            </h1>

            <p className="mt-5 text-base md:text-lg leading-relaxed text-foreground-700 max-w-xl">
              这一页侧重在线观看，把观看、播放、高清与免费几类信息集中在一起，同时补充全集收录与无广告说明。你可以先按题材与关键词找到目标作品，再决定从哪一部开始。
            </p>

            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <a
                href="#browse"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap transition-colors hover:bg-primary-600"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始浏览作品
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-300 bg-background-50 text-foreground-800 text-sm font-medium whitespace-nowrap transition-colors hover:bg-background-100"
              >
                <i className="ri-bar-chart-2-line text-lg"></i>
                查看本周排行
              </a>
            </div>

            <dl className="mt-9 grid grid-cols-3 gap-4 max-w-lg">
              {heroStats.map((stat) => (
                <div key={stat.label}>
                  <dt className="text-xs text-foreground-500">{stat.label}</dt>
                  <dd className="mt-1 font-heading text-xl md:text-2xl font-semibold text-foreground-950">
                    {stat.value}
                  </dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="relative">
            <div className="grid grid-cols-3 gap-3 md:gap-4">
              <div className="col-span-3 sm:col-span-2 sm:row-span-2 rounded-lg overflow-hidden border border-background-200 animate-floaty">
                <img
                  src="https://readdy.ai/api/search-image?query=Stylized%20anime%20key%20visual%20poster%20of%20two%20young%20travelers%20standing%20on%20a%20cliff%20edge%20beneath%20a%20vast%20starry%20ocean%20sky%2C%20painterly%20soft%20shading%2C%20warm%20sakura%20pink%20and%20deep%20amber%20palette%2C%20cinematic%20vertical%20illustration%2C%20dreamy%20atmosphere%2C%20no%20text&width=600&height=800&seq=anime-poster-01&orientation=portrait"
                  alt="星海彼岸的约定 作品主视觉海报"
                  title="星海彼岸的约定 奇幻动画海报"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="rounded-lg overflow-hidden border border-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Stylized%20anime%20key%20visual%20poster%20of%20a%20lone%20samurai%20walking%20a%20petal%20covered%20mountain%20path%20with%20a%20katana%20on%20the%20back%2C%20painterly%20soft%20shading%2C%20sakura%20pink%20and%20sunset%20gold%20palette%2C%20cinematic%20vertical%20illustration%2C%20no%20text&width=600&height=800&seq=anime-poster-03&orientation=portrait"
                  alt="剑与樱的旅途 作品主视觉海报"
                  title="剑与樱的旅途 热血动画海报"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="rounded-lg overflow-hidden border border-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Stylized%20anime%20key%20visual%20poster%20of%20a%20detective%20in%20a%20long%20coat%20on%20a%20foggy%20vintage%20city%20street%20at%20night%2C%20painterly%20soft%20shading%2C%20muted%20amber%20and%20teal%20palette%2C%20cinematic%20vertical%20illustration%2C%20mysterious%20mood%2C%20no%20text&width=600&height=800&seq=anime-poster-05&orientation=portrait"
                  alt="雾都侦探录 作品主视觉海报"
                  title="雾都侦探录 悬疑动画海报"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            <div className="absolute -bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:w-64 rounded-lg bg-background-50 border border-background-200 px-4 py-3">
              <div className="flex items-center gap-2 text-xs text-foreground-500">
                <i className="ri-fire-line text-primary-500"></i>
                今日更新
              </div>
              <p className="mt-1 text-sm font-medium text-foreground-900">6 部作品已更新 · 含 2 部完结</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}